import { UseQueryOptions, useQuery } from "@tanstack/react-query";

import { ResponseUser } from "../../types/account";

import userAPI from "../../api/userAPI";

export const userQueryKeys = {
  all: ["userInfo"] as const,
};

export function useFetchUserInfoQuery(
  options?: Omit<UseQueryOptions<ResponseUser>, "queryKey" | "queryFn">
) {
  const query = useQuery<ResponseUser>({
    queryKey: userQueryKeys.all,
    // NOTE 해당 부분 axiosClient를 hook에서 전달하도록 할 것인지 / api에서 바로 사용할 것인지 Review 필요
    queryFn: userAPI.getUserInfo,
    ...options,
  });

  return query;
}
